import axios from 'axios';

// Axios instance for S3 that won't attach the Authorization header
export const externalAxios = axios.create({});
